import { Createtask, Tasks, UpdateTask } from '@/entities/tasks';
import { TaskService } from '@/services/TaskService';
import { useEffect, useState } from 'react';

export function useTasks(businessId?:number){
  const [tasksR, setTasks] = useState<Tasks[]>([]);

  useEffect(()=>{
    getTasks();
  },[]);

  const getTasks = async () => {
    if(!businessId) return;
    const response = await TaskService.getTasks(businessId);
    if(response){
      setTasks(response);
    }
  };

  const updateTask = async (task:UpdateTask) => {
    const response = await TaskService.updateTask(task);
    if(response){
      return response;
    }
  };

  const updateTaskDone = async (task:UpdateTask) => {
    const response = await TaskService.updateTaskDone(task);
    if(response){
      return response;
    }
  };
  
  const createTasks = async (task:Createtask) => {
    const response = await TaskService.createTask(task);
    if(response){
      return response;
    }
  };

  const deleteTask = async (taskId:number) => {
    const response = await TaskService.deleteTask(taskId);
    if(response){
      return response;
    }
  };

  return{
    tasksR,
    getTasks,
    createTasks,
    updateTask,
    deleteTask,
    updateTaskDone
  };

}
